module.exports = __webpack_public_path__ + "img/crush.de79e7c1.jpg";